module.exports = __webpack_public_path__ + "static/forecast/weather/nightheavyrain-c463fa270e63241398dd2446e78283e1.svg";